// Product Add-ons Logic
document.addEventListener('DOMContentLoaded', function() {
  const addonCheckbox = document.getElementById('include-addon');
  
  if (!addonCheckbox) return;
  
  console.log('[Addons] Addon option available');
  
  // Set up the Add to Cart button interceptor
  setupAddonInterceptor();
});

function setupAddonInterceptor() {
  setTimeout(() => {
    const addToCartButtons = document.querySelectorAll('button[name="add"], button[type="submit"][form*="product-form"]');
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', async function(e) {
        const addonCheckbox = document.getElementById('include-addon');
        
        // Check if engraving is also selected - if so, let engraving script handle everything
        const engravingSelected = document.querySelector('input[name="engraving-option"]:checked')?.value === 'yes';
        if (engravingSelected) {
          console.log('[Addons] Engraving selected - letting engraving script handle cart');
          return;
        }
        
        // Only intercept if addon checkbox is checked
        if (addonCheckbox && addonCheckbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          console.log('[Addons] Intercepting Add to Cart - addon selected');
          await handleAddonSubmit(button, addonCheckbox);
        } else {
          console.log('[Addons] No addon selected - normal flow');
        }
      }, true);
    });
    
    console.log('[Addons] Setup complete');
  }, 500);
}

async function handleAddonSubmit(button, addonCheckbox) {
  const addonVariantId = addonCheckbox.getAttribute('data-addon-variant-id');
  const addonTitle = addonCheckbox.getAttribute('data-addon-title');
  
  if (!addonVariantId) {
    alert('Add-on product is not configured properly. Please contact support.');
    return;
  }
  
  // Find the form to get product ID and quantity
  const form = button.closest('form') || document.querySelector('form[action*="/cart/add"]');
  if (!form) {
    alert('Could not find product form.');
    return;
  }
  
  const idInput = form.querySelector('input[name="id"]');
  if (!idInput || !idInput.value) {
    alert('Could not find product variant. Please refresh and try again.');
    return;
  }
  
  const mainProductId = idInput.value;
  const quantityInput = form.querySelector('input[name="quantity"]');
  const quantity = parseInt(quantityInput?.value || 1);
  const productTitle = document.querySelector('h1')?.textContent?.trim() || 'Product';
  
  console.log('[Addons] Adding to cart:', {
    mainProductId,
    addonId: addonVariantId,
    quantity
  });
  
  const originalText = button.innerHTML;
  button.disabled = true;
  button.innerHTML = 'Adding to cart...';
  
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(mainProductId),
            quantity: quantity
          },
          {
            id: parseInt(addonVariantId),
            quantity: quantity,
            properties: {
              'Added with': productTitle
            }
          }
        ]
      })
    });
    
    const responseData = await response.json();
    console.log('[Addons] Cart response:', responseData);
    
    if (!response.ok) {
      throw new Error(responseData.description || responseData.message || 'Failed to add to cart');
    }
    
    console.log('[Addons] Success, redirecting to cart');
    window.location.href = '/cart';
    
  } catch (error) {
    console.error('[Addons] Error:', error);
    alert('Error adding to cart: ' + error.message);
    button.disabled = false;
    button.innerHTML = originalText;
  }
}
